exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_info .info[data-v-2ddb0134]{margin-left:10px}.goods_info .info p[data-v-2ddb0134]{color:#666666}.goods_info .info p[data-v-2ddb0134]:first-child{color:#999999}.bottomBtn[data-v-2ddb0134]{height:60px;line-height:70px;background:#ffffff;-webkit-box-shadow:0px -1px 0px 0px #eeeeee;box-shadow:0px -1px 0px 0px #eeeeee;text-align:center;margin-top:50px}\n", ""]);

// exports
